import { DownloadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Row } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import { XuatExcelThongKeLoiViPham } from '../../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';

const LoiViPhamNhanVien = () => {
    const dispatch = useDispatch();

    const [nam, setNam] = useState<string>(new Date().getFullYear().toString());
    const [namValue, setNamValue] = useState<Dayjs | null>(dayjs());
    const namFormat: DatePickerProps['format'] = (value) => `Năm ${value.format('YYYY')}`;

    const onClick = async () => {
        try {
            dispatch(showLoadingScreen());
            var response = await XuatExcelThongKeLoiViPham(parseInt(nam));
            let link = document.createElement('a');
            link.download = `ThongKeLoiViPham.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            dispatch(hideLoadingScreen());
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, vui lòng thử lại!');
            dispatch(hideLoadingScreen());
        }
    };
    const onChange: DatePickerProps['onChange'] = (year) => {
        var yearStr = year?.format('YYYY');
        setNamValue(year);
        if (yearStr) {
            setNam(yearStr);
        } else {
            setNam("");
        }
    }

    return (
            <Row gutter={[10,16]}>
                <Col span={4}>
                    <label>Lỗi vi phạm:</label>
                </Col>
                <Col span={5}>
                    <DatePicker changeOnBlur={true} value={namValue} style={{ width: "100%" }} placeholder="Năm" picker="year" format={namFormat} onChange={onChange} allowClear={false} />
                </Col>
                <Col>
                    <Button
                        className="hrm-btn hrm-btn-success"
                        htmlType="submit"
                        icon={<DownloadOutlined />}
                        onClick={onClick}
                    >Xuất excel
                    </Button>
                </Col>
            </Row>
    );
};

export default LoiViPhamNhanVien;
